import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const actions = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

/**
 * The pending Show details button is `aria-disabled`, not `disabled`, so it stays
 * focusable and its busy state is reachable. The design system keys its disabled
 * treatment off the `disabled` prop, which we therefore no longer pass — this
 * reproduces it (`cursor: not-allowed; opacity: 0.5`, uniform across variants).
 */
export const ariaDisabled = css`
  &[aria-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
